// generated by genversion
export var version = '3.4.6';
//# sourceMappingURL=version.js.map